module.exports = __webpack_public_path__ + "static/media/telecom3.146fe7f0.jpg";